// Capacidades de ClientesV2 según la superficie Y el rol. En clientes.eneural.org la
// gestión de cliente es COMPLETA salvo Técnico; en el panel es solo-lectura salvo Líneas y
// Técnico, y sin pestañas Contrato, Comercial, Pagos ni Historial.
//
// El ROL se cruza encima de la superficie: `implementador` es de SOLO LECTURA (ve todo lo
// que ve un admin en su superficie, pero no puede modificar nada).
//
// ⚠️ Esto es UI, no seguridad. Lo que impide de verdad que un implementador escriba es que
// no está en `ROLE_RANK` del backend (rango 0 ⇒ falla todos los `require_roles`). Acá solo
// se esconden los botones para no ofrecer acciones que van a terminar en 403.

// Roles de solo lectura. Si mañana hay otro (auditor, por ejemplo), va acá y nada más.
const ROLES_SOLO_LECTURA = new Set(['implementador']);

export function esSoloLectura(role) {
  return ROLES_SOLO_LECTURA.has(role);
}

export function capsForSurface(surface, role) {
  const esClientes = surface === 'clientes';
  const caps = {
    canCreate:    esClientes,   // alta de cliente (modal)
    canDelete:    esClientes,   // baja de cliente
    canToggle:    esClientes,   // activar/desactivar
    editDatos:    esClientes,   // pestaña Resumen
    editPago:     esClientes,   // pestaña Comercial (modo de pago/mandato)
    editPermisos: esClientes,   // pestaña Permisos (marcado por ANI)
    manageLineas: true,         // Líneas: editables en ambas superficies
    // Crear/borrar troncales exige rango admin en el backend (POST /v1/troncales usa
    // require_roles). Va aparte de manageLineas para no ofrecerle el botón a un `sac`,
    // que gestiona líneas pero no troncales y solo cosecharía un 403.
    manageTroncal: role === 'admin' || role === 'superadmin',
    showTecnico:  !esClientes,  // info técnica por línea (fila expandible en Líneas): solo panel
    showContrato: esClientes,   // Contrato (ver): solo en clientes; quitada del panel
    showComercial: esClientes,  // Comercial (modo de pago/mandato): solo en clientes; oculta en el panel
    showPagos:     esClientes,  // Pagos (historial): solo en clientes; oculta en el panel
    showHistorial: esClientes,  // Historial (actividad): solo en clientes; oculta en el panel
  };

  if (esSoloLectura(role)) {
    // Se apagan SOLO las capacidades de escritura. Las `show*` quedan como están: el
    // implementador tiene que poder VER las mismas pestañas, incluidas las credenciales
    // SIP, que las necesita para configurar el equipo en sitio.
    caps.canCreate = false;
    caps.canDelete = false;
    caps.canToggle = false;
    caps.editDatos = false;
    caps.editPago = false;
    caps.editPermisos = false;
    caps.manageLineas = false;
    caps.manageTroncal = false;
  }
  return caps;
}

export function tabsForSurface(surface) {
  // Sin rol a propósito: el implementador ve las MISMAS pestañas, solo sin botones.
  const c = capsForSurface(surface);
  // Orden fijo; Técnico solo en panel (antes de Líneas), Contrato solo en clientes
  // (después de Líneas). Líneas y las demás están siempre. Así la matriz de pestañas
  // sale de las MISMAS caps (showTecnico/showContrato), sin duplicar la decisión.
  return [
    'Resumen',
    ...(c.showComercial ? ['Comercial'] : []),
    'Líneas',
    ...(c.showContrato ? ['Contrato'] : []),
    ...(c.showPagos ? ['Pagos'] : []),
    ...(c.showHistorial ? ['Historial'] : []),
    'Permisos',
  ];
}
